export const assetVersionsLimitOptions = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: 'Full version history',
    value: 'full',
  },
];

export const assetVersionsLimitOptionsDictionary = assetVersionsLimitOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {} as Record<string, string>,
);
